import { apiClient, getActivePvzId, isSupabaseConfigured, clearCache } from './_shared.js'

// ============================================
// PAYMENTS (Премии / Штрафы)
// ============================================

export async function getPayments(filters = {}) {
  const pvzId = filters.pvzId || getActivePvzId()
  if (!isSupabaseConfigured) return []
  const params = new URLSearchParams()
  if (pvzId) params.append('pvzId', pvzId)
  if (filters.type) params.append('type', filters.type)
  if (filters.employeeId) params.append('employeeId', filters.employeeId)
  if (filters.periodStart) params.append('periodStart', filters.periodStart)
  if (filters.periodEnd) params.append('periodEnd', filters.periodEnd)
  const data = await apiClient('/payments?' + params.toString())
  return data.map(item => ({
    ...item,
    period_start: item.period_start?.split('T')[0],
    period_end: item.period_end?.split('T')[0],
    allocations: Array.isArray(item.allocations) ? item.allocations.map(a => ({
      ...a,
      period_start: a.period_start?.split('T')[0],
      period_end: a.period_end?.split('T')[0]
    })) : []
  }))
}

export async function getPaymentAllocations(filters = {}) {
  const pvzId = filters.pvzId || getActivePvzId()
  if (!isSupabaseConfigured) return []
  const params = new URLSearchParams()
  if (pvzId) params.append('pvzId', pvzId)
  if (filters.employeeId) params.append('employeeId', filters.employeeId)
  if (filters.paymentId) params.append('paymentId', filters.paymentId)
  if (filters.periodStart) params.append('periodStart', filters.periodStart)
  if (filters.periodEnd) params.append('periodEnd', filters.periodEnd)
  return await apiClient('/payments/allocations?' + params.toString())
}

export async function createPayment(payment) {
  if (!isSupabaseConfigured) return null

  const payload = {
    pvz_id: getActivePvzId(),
    employee_id: payment.employee_id,
    type: payment.type,
    amount: payment.amount,
    period_start: payment.period_start,
    period_end: payment.period_end,
    comment: payment.comment || null,
    created_by: payment.created_by,
    evidence_url: payment.evidence_url || null,
    reason_code: payment.reason_code || null,
    allocations: payment.allocations || null,
  }

  // Поддержка принудительной отправки при перекрытии периодов
  if (payment.force_overlap) {
    payload.force_overlap = true
  }

  const data = await apiClient('/payments', {
    method: 'POST',
    body: JSON.stringify(payload)
  })

  clearCache('payments')
  return data
}

export async function updatePayment(id, updates) {
  if (!isSupabaseConfigured) return null

  const data = await apiClient(`/payments/${id}`, {
    method: 'PUT',
    body: JSON.stringify(updates)
  })

  clearCache('payments')
  return data
}

export async function deletePayment(id) {
  if (!isSupabaseConfigured) return null

  await apiClient(`/payments/${id}`, {
    method: 'DELETE'
  })

  clearCache('payments')
}

export async function clearRejectedPayments() {
  if (!isSupabaseConfigured) return null
  await apiClient('/payments/rejected', { method: 'DELETE' })
  clearCache('payments')
}

export async function disputePayment(id, comment, evidenceUrl = null, disputeVideoUrl = null) {
  if (!isSupabaseConfigured) return null
  return await apiClient(`/payments/${id}/dispute`, {
    method: 'PUT',
    body: JSON.stringify({
      comment,
      evidence_url: evidenceUrl,
      dispute_video_url: disputeVideoUrl
    })
  })
}
